import axiosInstance from './axiosInstance';
import { LOGOUT } from '../API';
import { toast } from 'react-toastify';

export const clearAuthData = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("consultationId");
};

export const isAuthenticated = () => {
    return !!localStorage.getItem("userToken");
};

export const logout = async (navigate) => {
    try {
        const res = await axiosInstance.post(LOGOUT)
        if (res?.status === 200) {
            clearAuthData();
            toast.success("Logged out successfully.");
            if (navigate) { navigate('/login') }
        }
    }
    catch (error) { console.error("Backend logout failed, proceeding with client cleanup", error); }

};
